
// 没有导出，直接在min.js引用

import { getQueryStr } from './index';
//第一个参数为事件触发后需要执行的方法，第二个参数为延时时间
function debounce(method, delay) {
    let timer = null;
    return function () {
        let context = this, args = arguments;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        timer = setTimeout(function () {
            method.apply(context, args);
        }, delay);
    }
}
function fn() {
    // 
    let orgId = getQueryStr('orgId')
    let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    if (orgId && htmlWidth < 900) {
        window.location.href = window.config.M_URL + '/?orgId=' + orgId
    }
}

fn()
window.addEventListener('resize', debounce(fn, 600));


// 禁用双指放大
document.documentElement.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
        event.preventDefault();
    }
}, {
    passive: false
});

// 禁用双击放大
let lastTouchEnd = 0;
document.documentElement.addEventListener('touchend', function (event) {
    let now = Date.now();
    if (now - lastTouchEnd <= 300) {
        event.preventDefault();
    }
    lastTouchEnd = now;
}, {
    passive: false
});


// WEBPACK FOOTER //
// ./src/utils/onresize.js